import {
  GET_DOCUMENTATION,
  UPLOAD_DOCUMENTATION,
  GET_USER_MANUAL,
} from "./types";

const initialState = {
  documentation: [],
  userManual: null,
  loading: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_DOCUMENTATION:
      return {
        ...state,
        documentation: action.payload,
      };
    case UPLOAD_DOCUMENTATION:
      return {
        ...state,
        loading: action.payload,
      };
    case GET_USER_MANUAL:
      return {
        ...state,
        userManual: action.payload,
      };
    default:
      return state;
  }
};
